import AboutusSection from "../components/AboutUsComponents/AboutusSection";
import HeroSection from "../components/HomeComponents/HeroSection";
import HomeAbout from "../components/HomeComponents/HomeAbout";
import HomeAboutusSection from "../components/HomeComponents/HomeAboutusSection";
import HomeApproach from "../components/HomeComponents/HomeApproach";
import HomeGetInTouch from "../components/HomeComponents/HomeGetInTouch";
import HomeHowWeWork from "../components/HomeComponents/HomeHowWeWork";
// import HomeHeroSection from "../components/HomeComponents/HomeHeroSection";
// import HomeServices from "../components/HomeComponents/HomeServices";
import HomeWhyChooseUs from "../components/HomeComponents/HomeWhyChooseUs";
import SpecialServices from "../components/HomeComponents/SpecialServices";
// import NewsHighlight from "../components/News/newsHighlisght";
import NewsPress from "../components/News/NewsPress";

// import NewsHeroSection from "../components/News/NewsHeroSection";
import newsData from "../NewsData/newsData";
const Home = () => {
  return (
    <div style={{width:'100%'}}>
      {/* <HomeHeroSection /> */}
      <HeroSection />
      <HomeAbout />
      <HomeAboutusSection />
      <div style={{padding:'30px'}}>
        <NewsPress data={newsData} />
      </div>
      {/* <NewsHeroSection /> */}
      {/* <HomeServices /> */}
      {/* <HomeHowWeWork /> */}
      <SpecialServices />
      <HomeApproach />
      <HomeWhyChooseUs />
      {/* <div style={{marginBottom:'20px'}}> */}
        <HomeGetInTouch />
      {/* </div> */}
    </div>
  );
};

export default Home;